import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const fmt = (n) => "₹" + Number(n || 0).toLocaleString("en-IN");

export function FundingInvoiceSelect({ funds, value, onChange, testid = "funding-invoice-select", required = true }) {
  const list = funds?.invoices || [];
  const sel = list.find((i) => i.id === value);
  return (
    <div className="space-y-2">
      <Label>Paid From Sales Invoice {required && <span className="text-rose-400">*</span>}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={testid}><SelectValue placeholder="Select invoice with received amount" /></SelectTrigger>
        <SelectContent>
          {list.length === 0 ? (
            <div className="px-3 py-2 text-sm text-muted-foreground" data-testid={`${testid}-empty`}>No invoice receipts yet. Receive payment on a Sales Invoice first.</div>
          ) : list.map((i) => (
            <SelectItem key={i.id} value={i.id} disabled={i.available <= 0}>
              {i.invoice_no} · {i.party_name} · available {fmt(i.available)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {sel && (
        <p className="text-xs text-muted-foreground">
          Received {fmt(sel.received)} · Used {fmt(sel.used_expenses + sel.used_vendor)} · <span className="text-emerald-400 font-mono-sku">Available {fmt(sel.available)}</span>
        </p>
      )}
    </div>
  );
}
